export default "__VITE_PUBLIC_ASSET__acce1796__"